import React from 'react';
import { useSettingsStore } from '../../stores/settingsStore';

const Footer: React.FC = () => {
  const { companyName } = useSettingsStore();
  
  return (
    <footer className="bg-white dark:bg-boxdark-2 text-bodydark2 p-4 shadow-inner">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <p>&copy; {new Date().getFullYear()} {companyName}. All rights reserved.</p>
        </div>
        <div className="flex flex-wrap justify-center gap-x-4">
          <a href="https://reloam.ainaeco.uk/terms" target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[40px] items-center hover:text-primary md:min-h-0">Terms of Service</a>
          <a href="https://reloam.ainaeco.uk/privacy" target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[40px] items-center hover:text-primary md:min-h-0">Privacy Policy</a>
          <a href="mailto:reloam@ainaeco.uk" className="inline-flex min-h-[40px] items-center hover:text-primary md:min-h-0">Contact Us</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;